import {Component} from '@angular/core';
import {Router} from '@angular/router';

import {UserService} from "../../services/user.service";
import {AlertService} from "../../services/alert.service";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})

export class RegisterComponent {
  loading = false;
  registerForm:FormGroup;

  constructor(private router:Router,
              private userService:UserService,
              private alertService:AlertService,
              private fb:FormBuilder) {
    this.registerForm = fb.group({
      'name': [null, Validators.required],
      'email': [null, Validators.compose([Validators.required, Validators.email])],
      'password': [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(10)])]
    })
  }

  submitForm(value:any) {
    this.loading = true;
    this.userService.create(value)
      .subscribe(
        data => {
          this.alertService.success('Registration successful', true);
          this.router.navigate(['/login']);
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/register/register.component.ts